<template>
  <van-collapse v-model="activeName" accordion>
    <van-collapse-item
      v-for="(item, index) in list"
      :name="index"
      :key="index"
      :title="item.customerName"
    >
      <div class="content">
        <div class="list">
          <span class="list-left">手机号</span>
          <span class="list-right">{{ item.phone }}</span>
        </div>
        <div class="list">
          <span class="list-left">参与时间</span>
          <span class="list-right">{{ item.createdTime }}</span>
        </div>
        <div class="list">
          <span class="list-left">数钱次数</span>
          <span class="list-right">{{ item.times }}</span>
        </div>
        <div class="list">
          <span class="list-left">全国排名数据</span>
          <span class="list-right">{{ item.allRankNo }}</span>
        </div>
        <div class="list">
          <span class="list-left">省区排名数据</span>
          <span class="list-right">{{ item.orgRankNo }}</span>
        </div>
        <div class="list">
          <span class="list-left">中奖数量</span>
          <span class="list-right">{{ item.winTimes }}</span>
        </div>
        <div class="list">
          <span class="list-left">奖品信息</span>
          <span class="list-right color" @clikc="lookInfo(item)">点击查看</span>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      activeName: [],
    };
  },
  methods: {
    lookInfo(item) {
      this.$route.push({
        path: '/countMoney-info',
        query: {
          activityId: this.$route.query.activityId,
          participationId: item.id
        }
      })
    }
  }
};
</script>
<style lang="stylus" scoped>
.content {
  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 0;
    color: #999999;
    font-size: 14px;
    .list-right {
      position relative
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 230px;
      flex-wrap: wrap;
      color: #333333;
    }
    .color {
      color: #ff6B31;
    }
  }
}
</style>
